import React from 'react';
import FormFieldHeader from './FormFieldHeader.js';

const Textfield = (props) => (
	<div className="mdl-textfield">
		{props.header ?
		<FormFieldHeader
			header={props.header}
			help={props.help} /> : null}
		<input {...props} placeholder={props.placeholder || (props.header ? `${props.header}...` : "")} className="mdl-textfield__input" type="text" />
	</div>
)

export default Textfield



// WEBPACK FOOTER //
// ./src/components/form/Textfield.js